export default __webpack_public_path__ + "static/media/stone06.6ef26031.png";